export default __webpack_public_path__ + "static/grouped-column-f442330bfc5ce9d2b167e7ab0202af84.png";